/* eslint-disable max-len */
import { Card, Grid } from '@material-ui/core';
import React from 'react';

import HoSoViewAdmin from '../../../containers/KVC/HoSo/HoSoDetail';
import DanhSachThanhTichProfile from '../../../containers/QCV/DanhSachThanhTich/DanhSachThanhTichProfile';

// Màn "Duyệt thành tích riêng" của KVC: trái là thông tin ứng viên
// (DanhSachThanhTichProfile dùng chung với QCV), phải là các bảng thành tích
// khoa học (mục B) của HoSoViewAdmin ở chế độ `achievementsOnly` — mỗi thành
// tích có tác vụ chấm điểm (DuyetThanhTichModalV2) khi isSuperAdmin.
function DuyetThanhTich() {
  const arrayPath = window.location.href.split('/');
  const formId = parseInt(arrayPath.slice(arrayPath.length - 1));

  return (
    <Grid container spacing={2} style={{ marginTop: 32 }}>
      <Grid item xs={12} md={3}>
        <DanhSachThanhTichProfile formId={formId} />
      </Grid>
      <Grid item xs={12} md={9}>
        <Card style={{ padding: 8, minHeight: 'calc(100vh - 124px)' }}>
          <HoSoViewAdmin isSuperAdmin achievementsOnly />
        </Card>
      </Grid>
    </Grid>
  );
}

export default DuyetThanhTich;
